<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M3,3H21V5H3V3M3,7H21V9H3V7M3,11H21V13H3V11M3,15H21V17H3V15M3,19H21V21H3V19Z"/>
    </svg>
</template>

<script>
export default {
    name: 'FormatAlignJustifyIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
